import { useEffect } from 'react';

const ViewportHelper = () => {
  useEffect(() => {
    // Store original viewport content
    const viewport = document.querySelector('meta[name="viewport"]');
    const originalContent = viewport?.getAttribute('content') || '';

    // Update viewport to prevent zoom on input focus
    if (viewport) {
      viewport.setAttribute(
        'content',
        'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no'
      );
    }

    // Restore original viewport on unmount
    return () => {
      if (viewport) {
        viewport.setAttribute('content', originalContent);
      }
    };
  }, []);

  return null;
};

export default ViewportHelper;